/**
 * UUID Generation Utility
 * Works in both browser and Node.js environments
 */

/**
 * Generate a UUID that works in both browser and Node.js
 * - Uses globalThis.crypto.randomUUID (available in modern browsers and Node.js >=19)
 * - Fallback: manual UUID v4 generation for older environments
 */
export function generateUUID(): string {
	if (typeof globalThis.crypto?.randomUUID === 'function') {
		return globalThis.crypto.randomUUID();
	}

	// Fallback for older environments - generate UUID v4 manually
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0;
		const v = c === 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}
